import React, { Component } from 'react';
import moment from 'moment';
import {
  Row,
  Col,
  Table,
  Container,
  Button,
  TabPane,
  TabContent,
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import { toast } from 'react-toastify';
import { Link, withRouter } from 'react-router-dom';
import fileDownload from 'js-file-download';
import { Parser } from 'json2csv';
import CheckIcon from 'mdi-react/CheckIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import DotsHorizontalIcon from 'mdi-react/DotsHorizontalIcon';
import DragIcon from 'mdi-react/DragIcon';
import DownloadIcon from 'mdi-react/DownloadIcon';
import EditOutlineIcon from 'mdi-react/EditOutlineIcon';
import DeleteOutlineIcon from 'mdi-react/DeleteOutlineIcon';
import UserAddOutlineIcon from 'mdi-react/UserAddOutlineIcon';
import ImageOutlineIcon from 'mdi-react/ImageOutlineIcon';
import exportToExcelFile from '../../util/xlsx';
import Api from '../../util/api';
import Loading from '../../shared/components/custom/Loading';
import Pagination from '../../shared/components/pagination/Pagination';
import DeleteModal from '../../shared/components/custom/DeleteModal';
import SortDirection from '../../shared/components/custom/SortDirection';
import NavTab from '../../shared/components/custom/NavTab';
import t, { partial } from '../../util/translation/translation';
import AppSponsor from './components/AppSponsor';
import { convertImageToBlob } from '../../util/image-functions';
import LinkModal from '../../shared/components/custom/LinkModal';
import ShareModal from '../../shared/components/custom/ShareModal';
import GroupForm from './components/GroupForm';
import LevelInformation from './components/LevelInformation';
import { capitalizeFirstLetter } from '../../util/functions';
import AlertModal from '../../shared/components/custom/AlertModal';
import SquareIconButton from '../../shared/components/custom/SquareIconButton';
import FormCard from '../../shared/components/custom/FormCard';
import useConfig from '../../util/useConfig';
import GoalServiceSponsor from './components/GoalServiceSponsor';
import config from '../../config';
import WebsiteSponsor from './components/WebsiteSponsor';
import CompanyStatisticsOverview from './components/CompanyStatisticsOverview';
import CompanyCategoryBreakdown from './components/CompanyCategoryBreakdown';
import CompanyLevelBreakdown from './components/CompanyLevelBreakdown';

const s = partial('shared');
const p = partial('CompanyListPage');
const ct = partial('Category');
const a = partial('AlertModal');
const sv = partial('SponsorViews');

const SettingType = {
  GROUP: 'group',
  LEVEL: 'level',
};

class CompanyListPage extends Component {
  constructor() {
    super();
    this.state = {
      companies: {
        total: 0,
        current_page: '1',
        per_page: '25',
        page: 1,
        data: [],
      },
      order: 'name',
      reverse: false,
      searchText: '',
      searchIn: '',
      loadingCompanies: false,
      loadingSponsor: false,
      linkModalVisible: false,
      modalVisible: false,
      selectedCompanyID: null,
      loadingSettings: false,
      clubProfile: null,
      isAppVisible: true,
      isSponsor: true,
      tab: '',
      deleteModal: {
        visible: false,
        settingID: null,
        type: 'level',
      },
      groupModal: {
        visible: false,
        groupState: null,
        type: '',
      },
      levelModal: {
        visible: false,
        levelState: null,
        type: '',
      },
      settingState: false,
      groups: [],
      levels: [],
      selectedCompanies: [],
      companyFilter: 'all',
      // Viewers per company in the latest month, for clubs that collect them
      sponsorViews: { enabled: false, month: null, viewers: {} },
    };
  }

  componentDidMount() {
    this.getGroupsAndLevels();
    this.getSponsorViews();
  }

  getSponsorViews = async () => {
    try {
      const status = await Api.companies.sponsorViews.getStatus();
      if (!status?.enabled) return;
      const result = await Api.companies.sponsorViews.getCompanies();
      this.setState({
        sponsorViews: {
          enabled: true,
          month: result.viewersMonth,
          viewers: Object.fromEntries(
            result.companies.map((row) => [row.companyId, row.viewers])
          ),
        },
      });
    } catch {
      // Without the numbers the list is shown as before
    }
  };

  onChangePage = (pager) => {
    if (
      pager.pageSize !== this.state.companies.per_page ||
      pager.currentPage !== this.state.companies.current_page
    ) {
      this.getCompanies(pager.currentPage, pager.pageSize);
    }
  };

  addDeleteCompaniesFromGroupOrLevel = async (fieldValue, type) => {
    const { selectedCompanies } = this.state;
    try {
      const selectedCompaniesIds = selectedCompanies.map((x) => x.id);
      let resSelectedCompanies = [];
      if (type === SettingType.GROUP) {
        resSelectedCompanies =
          await Api.companies.getCompaniesForGroup(fieldValue);
      } else {
        resSelectedCompanies = await Api.club.getCompaniesForLevel(fieldValue);
      }
      const initiallySelected = resSelectedCompanies.map((x) => x.id);
      const toDelete = initiallySelected.filter(
        (x) => !selectedCompaniesIds.includes(x)
      );
      const toAdd = selectedCompaniesIds.filter(
        (x) => !initiallySelected.includes(x)
      );
      const promises = [];
      if (toDelete.length) {
        promises.push(
          type === SettingType.GROUP
            ? Api.club.deleteCompaniesFromGroup({
                companyId: toDelete,
                fieldValue,
              })
            : Api.club.deleteCompaniesFromLevel({
                companyId: toDelete,
                fieldValue,
              })
        );
      }
      if (toAdd.length) {
        promises.push(
          type === SettingType.GROUP
            ? Api.club.addCompaniesToGroup({ companyId: toAdd, fieldValue })
            : Api.club.addCompaniesToLevel({ companyId: toAdd, fieldValue })
        );
      }
      await Promise.all(promises);
    } catch (err) {
      toast.error(err || `${s('400')}`);
    }
  };

  handleModalTypeChangeToEdit = () => {
    const { levelModal, groupModal } = this.state;
    const key = levelModal.visible ? SettingType.LEVEL : SettingType.GROUP;
    if (key === SettingType.LEVEL) {
      this.setState({ levelModal: { ...levelModal, type: 'edit' } });
    } else {
      this.setState({ groupModal: { ...groupModal, type: 'edit' } });
    }
  };

  onSubmitSetting = async (values) => {
    const { levelModal, groupModal } = this.state;
    const key = levelModal.visible ? SettingType.LEVEL : SettingType.GROUP;
    const type = key === SettingType.LEVEL ? levelModal.type : groupModal.type;
    this.setState(
      {
        loadingSettings: true,
      },
      async () => {
        try {
          if (type === 'edit') {
            await this.addDeleteCompaniesFromGroupOrLevel(
              key === SettingType.GROUP
                ? groupModal?.groupState.value
                : levelModal?.levelState.value,
              key
            );
          }

          if (type === 'create') {
            const payload = {
              key: capitalizeFirstLetter(key),
              value: values.name,
            };

            await Api.club.createSetting(payload);
            toast.success(`${p(`${key}Created`)}`);
            this.getGroupsAndLevels();
          } else if (type === 'edit') {
            const payload = {
              id:
                key === SettingType.LEVEL
                  ? levelModal?.levelState?.id
                  : groupModal?.groupState.id,
              value: values.name,
              key: capitalizeFirstLetter(key),
            };
            await Api.club.editSetting(payload);
            toast.success(`${p(`${key}Updated`)}`);
            this.getGroupsAndLevels();
          }
        } catch (err) {
          toast.error(err || `${s('somethingWentWrong')}`);
          this.getGroupsAndLevels();
        } finally {
          this.setState({
            loadingSettings: false,
            levelModal: { visible: false, levelState: null, type: '' },
            groupModal: { visible: false, groupState: null, type: '' },
          });
        }
      }
    );
  };

  getCompanies = (
    page = this.state.companies.current_page,
    pageSize = this.state.companies.per_page
  ) => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getCompanies(
          pageSize,
          page,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        this.setState({
          companies: {
            ...this.state.companies,
            data: resCompanies.data.data,
            total: resCompanies.data.total,
          },
          loadingCompanies: false,
        });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('companiesFetchingERROR')}`);
      }
    });
  };

  hasImageThenConvert = async (image) => {
    const hasImage = Array.isArray(image) && image.length === 1;
    if (!hasImage) {
      return '';
    }
    if (image[0].size === undefined) {
      return image[0];
    }
    try {
      return {
        ...image[0],
        preview: await convertImageToBlob(image[0]),
      };
    } catch (err) {
      toast.error(err || `${s('imageUploadingERROR')}`);
      throw err;
    }
  };

  handleModal = (state, companyID) => {
    this.setState({ modalVisible: state, selectedCompanyID: companyID });
  };

  handleLinkModal = (state, companyID) => {
    this.setState({ linkModalVisible: state, selectedCompanyID: companyID });
  };

  displayCategories = (company) => {
    const categories =
      company?.companyCategories
        ?.map((x) => {
          try {
            return ct(x);
          } catch (e) {
            toast.error(e || s('somethingWentWrong'));
            return x;
          }
        })
        ?.join(', ') || '-';
    return (
      <>
        <div id={`tooltip-${company.id}`}>
          {' '}
          {`${categories.length > 50 ? `${categories.substring(0, 20)}...` : categories}`}
        </div>
        {categories.length > 50 && (
          <UncontrolledTooltip
            placement="left"
            target={`tooltip-${company.id}`}
          >
            {categories}
          </UncontrolledTooltip>
        )}
      </>
    );
  };
  handleSettingDeleteModal = (settingID = null, type = 'level') => {
    this.setState({ deleteModal: { visible: !!settingID, settingID, type } });
  };

  listCompanies = () => {
    const { history } = this.props;
    return this.state.companies.data.map((company) => (
      <tr key={`Company-${company.id}`}>
        <td>
          <div className="flex alignItems-center" style={{ gap: 8 }}>
            {company?.images?.companyImage ? (
              <img
                className="company__profile__avatar"
                src={company?.images?.companyImage}
                alt="logo"
              />
            ) : (
              <span className="company__profile__avatar_placeholder">
                {company?.name[0]?.toUpperCase()}
              </span>
            )}
            <Link to={`/companies/edit/${company.id}?tab=1`}>
              {company.name}
            </Link>
          </div>
        </td>
        <td>{company.employeeCount}</td>
        <td>
          <div>{company.companyLevel || '-'}</div>
          <small className="text-muted">
            {this.displayCategories(company)}
          </small>
        </td>
        <td>
          <div className="status-dot-group">
            <span
              className={`status-dot ${company.isSponsor ? 'status-dot--on' : 'status-dot--off'}`}
              title={s('sponsor')}
            >
              {company.isSponsor ? <CheckIcon /> : <CloseIcon />}
            </span>
            <span
              className={`status-dot ${company.isAppVisible ? 'status-dot--on' : 'status-dot--off'}`}
              title={s('visibleInApp')}
            >
              {company.isAppVisible ? <CheckIcon /> : <CloseIcon />}
            </span>
          </div>
        </td>
        {this.state.sponsorViews.enabled && (
          <td>
            {Number(
              this.state.sponsorViews.viewers[company.id] || 0
            ).toLocaleString()}
          </td>
        )}
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=1`)
              }
              title={s('edit')}
              id={`edit-${company.id}`}
            />
            <SquareIconButton
              icon={<UserAddOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=2`)
              }
              title={p('addContactPerson')}
              id={`add-${company.id}`}
            />
            <SquareIconButton
              icon={<ImageOutlineIcon />}
              onClick={() =>
                history.push(`/companies/edit/${company.id}?tab=3`)
              }
              title={p('sponsorMaterial')}
              id={`sponsor-${company.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() => this.handleModal(true, company.id)}
              title={s('delete')}
              tone="danger"
              id={`delete-${company.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  getGroupsAndLevels = async () => {
    try {
      const [levels, groups] = await Promise.all([
        Api.club.getLevels(),
        Api.club.getGroups(),
      ]);

      let groupCompaniesCount = {};
      let levelCompaniesCount = {};
      if (groups?.length) {
        groupCompaniesCount =
          await Api.companies.getCompaniesCountForGroups(groups);
      }
      if (levels?.length) {
        levelCompaniesCount =
          await Api.companies.getCompaniesCountForLevels(levels);
      }
      const levelsWithCount = levels.map((level) => {
        return {
          ...level,
          count:
            levelCompaniesCount?.find((l) => l.value === level.value)?.count ??
            0,
        };
      });
      const groupsWithCount = groups.map((group) => {
        return {
          ...group,
          count:
            groupCompaniesCount?.find((g) => g.value === group.value)?.count ??
            0,
        };
      });

      this.setState({ groups: groupsWithCount, levels: levelsWithCount });
    } catch (err) {
      toast.error(err || `${s('400')}`);
    }
  };

  handleSort = (order) => {
    const reverse =
      this.state.order === order ? !this.state.reverse : this.state.reverse;
    this.setState({ order, reverse }, () => {
      this.getCompanies();
    });
  };

  handleInput = (e) => {
    this.setState({ searchText: e.target.value });
  };

  handleSearch = (e) => {
    if (e.key === 'Enter') {
      this.getCompanies();
    }
  };

  updateSelectedCompanies = (companiesSelected) => {
    this.setState({ selectedCompanies: companiesSelected });
  };

  exportCompanies = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getClubCompanies();
        const fields = [
          { label: 'Name', value: 'name' },
          { label: 'VAT', value: 'organization_number' },
          { label: 'Phone', value: 'phone' },
          { label: 'email', value: 'email' },
          { label: 'Level', value: 'companyLevel' },
          {
            label: `${t('CompanyForm.companyCategory')}`,
            value: 'companyCategories',
          },
          { label: `${s('sponsor')}`, value: 'sponsor' },
          { label: `${s('visibleInApp')}`, value: 'visibleInApp' },
        ];
        const transformedCompanyData = resCompanies.map((company) => ({
          ...company,
          companyCategories: company?.companyCategories?.join(', ') || '',
          sponsor: company?.isSponsor ? s('yes') : s('no'),
          visibleInApp: company?.isAppVisible ? s('visible') : s('inVisible'),
        }));
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(transformedCompanyData);
        fileDownload(`\uFEFF${csv}`, `${p('exportCompany')}.csv`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportCompaniesXLSX = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const resCompanies = await Api.companies.getClubCompanies();
        const data = resCompanies.map((i) => {
          const result = {};
          result[`${s('companyName')}`] = i?.name;
          result[`${s('organizationNumber')}`] = i?.organization_number;
          result[`${s('phone')}`] = i?.phone;
          result[`${s('email')}`] = i?.email;
          result[`${s('level')}`] = i?.companyLevel;
          result[`${t('CompanyForm.companyCategory')}`] =
            i?.companyCategories?.join(', ') || '';
          result[`${s('sponsor')}`] = i?.isSponsor ? s('yes') : s('no');
          result[`${s('visibleInApp')}`] = i?.isAppVisible
            ? s('visible')
            : s('inVisible');
          return result;
        });
        exportToExcelFile(data, `${p('exportCompany')}`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportEmployees = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const { data: resEmployees } =
          await Api.companies.getAllCompaniesEmployees();

        const { data: companiesGroups } =
          await Api.companies.getAllGroupsForAllCompaniesByFieldType('Group');

        const resCompanies = await Api.companies.getCompanies(
          this.state.companies?.total || 50,
          1,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        const resEmployeesWithMetaData = resEmployees.map((emp) => {
          const groups = companiesGroups[emp.company.id] || [];
          return {
            ...emp,
            level:
              resCompanies.data?.data?.find(
                (comp) => comp.companyId === emp.company.id
              )?.companyLevel || '-- --',
            group: Array.isArray(groups) ? groups.join(',') : groups || '-- --',
            visibleInApp: resCompanies.data?.data?.find(
              (comp) => comp.companyId === emp.company.id
            )?.isAppVisible,
          };
        });
        const mappedEmployees = resEmployeesWithMetaData
          .map((emp) => {
            let primaryContact = '';
            let vip = '';

            if (emp.status === 'PRIMARY_AND_VIP') {
              primaryContact = 'true';
              vip = 'true';
            } else if (emp.status === 'PRIMARY_CONTACT') {
              primaryContact = 'true';
            } else if (emp.status === 'VIP') {
              vip = 'true';
            } else {
              primaryContact = '';
              vip = '';
            }
            return {
              compName: emp.company.generalName,
              vat: emp.company.organization_number,
              firstName: emp.firstName,
              lastName: emp.lastName,
              email: emp.email,
              phone: emp.phone,
              connected: !!emp.userId,
              primaryContact,
              vip,
              level: emp.level,
              group: emp.group,
              partnerVisibility: emp?.visibleCompany
                ? s('visible')
                : s('inVisible'),
              visibleInApp: emp?.visibleInApp ? s('visible') : s('inVisible'),
            };
          })
          .sort((first, second) =>
            first.compName.localeCompare(second.compName)
          );
        const fields = [
          { label: s('companyName'), value: 'compName' },
          { label: 'VAT', value: 'vat' },
          { label: t('AddEmployee.firstName'), value: 'firstName' },
          { label: t('AddEmployee.lastName'), value: 'lastName' },
          { label: s('email'), value: 'email' },
          { label: s('phone'), value: 'phone' },
          { label: p('connected'), value: 'connected' },
          { label: t('AddEmployee.primaryContact'), value: 'primaryContact' },
          { label: 'vip', value: 'vip' },
          { label: s('level'), value: 'level' },
          { label: s('group'), value: 'group' },
          {
            label: t('Reports.visibleForPartners'),
            value: 'partnerVisibility',
          },
          { label: s('visibleInApp'), value: 'visibleInApp' },
        ];
        const json2csvParser = new Parser({ fields });
        const csv = json2csvParser.parse(mappedEmployees);
        fileDownload(`\uFEFF${csv}`, `${p('exportEmployees')}.csv`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  exportEmployeesXLSX = () => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        const { data: resEmployees } =
          await Api.companies.getAllCompaniesEmployees();
        const { data: companiesGroups } =
          await Api.companies.getAllGroupsForAllCompaniesByFieldType('Group');
        const resCompanies = await Api.companies.getCompanies(
          this.state.companies?.total || 50,
          1,
          this.state.searchText,
          this.state.order,
          this.state.reverse,
          this.state.isAppVisible,
          this.state.isSponsor,
          this.state.searchIn
        );
        const resEmployeesWithMetaData = resEmployees.map((emp) => {
          const groups = companiesGroups[emp.company.id] || [];
          return {
            ...emp,
            level:
              resCompanies.data?.data?.find(
                (comp) => comp.companyId === emp.company.id
              )?.companyLevel || '-- --',
            group: Array.isArray(groups) ? groups.join(',') : groups || '-- --',
            visibleInApp: resCompanies.data?.data?.find(
              (comp) => comp.companyId === emp.company.id
            )?.isAppVisible,
          };
        });

        const data = resEmployeesWithMetaData.map((emp) => {
          let primaryContact = '';
          let vip = '';

          if (emp.status === 'PRIMARY_AND_VIP') {
            primaryContact = 'true';
            vip = 'true';
          } else if (emp.status === 'PRIMARY_CONTACT') {
            primaryContact = 'true';
          } else if (emp.status === 'VIP') {
            vip = 'true';
          } else {
            primaryContact = '';
            vip = '';
          }
          const result = {};
          result[`${s('companyName')}`] = emp?.company.generalName;
          result['VAT'] = emp?.company.organization_number;
          result[`${t('AddEmployee.firstName')}`] = emp?.firstName;
          result[`${t('AddEmployee.lastName')}`] = emp?.lastName;
          result[`${s('email')}`] = emp?.email;
          result[`${s('phone')}`] = emp?.phone;
          result[`${p('connected')}`] = emp?.userId;
          result[`${t('AddEmployee.primaryContact')}`] = primaryContact;
          result['VIP'] = vip;
          result[`${s('level')}`] = emp?.level;
          result[`${s('group')}`] = emp?.group;
          result[`${t('Reports.visibleForPartners')}`] = emp?.visibleCompany
            ? s('visible')
            : s('inVisible');
          result[`${s('visibleInApp')}`] = emp?.visibleInApp
            ? s('visible')
            : s('inVisible');
          return result;
        });

        exportToExcelFile(data, `${p('exportEmployees')}`);
        this.setState({ loadingCompanies: false });
      } catch (err) {
        this.setState({ loadingCompanies: false });
        toast.error(err || `${p('listExportingERROR')}'!'`);
      }
    });
  };

  removeCompany = (companyID) => {
    this.setState({ loadingCompanies: true }, async () => {
      try {
        await Api.companies.unlinkCompany({
          companyId: companyID,
          deleteComment: '',
        });
        this.setState({ modalVisible: false });
        this.getCompanies();
      } catch (err) {
        this.setState({ modalVisible: false, loadingCompanies: false });
        toast.error(err || `${p('companyDeletingERROR')}'!'`);
        this.getCompanies();
      }
    });
  };

  categoryOnDragEnd = ({ destination, source }) => {
    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    const draggedLevel = this.state.levels[source.index];
    const newLevels = [...this.state.levels];
    newLevels.splice(source.index, 1);
    newLevels.splice(destination.index, 0, draggedLevel);
    this.setState({ levels: newLevels, loadingSettings: true }, async () => {
      const order = newLevels.map((level, index) => ({
        id: level.id,
        order: index,
      }));
      try {
        await Api.club.updateSettingsOrder({ settingOrders: order });
        toast.success(`${p('categoryOrderUpdated')}`);
        this.setState({ loadingSettings: false });
      } catch (err) {
        this.setState({ loadingSettings: false });
        toast.error(err || `${p('orderUpdatingERROR')}`);
      }
    });
  };

  handleSettingViewClick = (setting, type) => {
    if (type === SettingType.GROUP) {
      this.setState({
        groupModal: { visible: true, groupState: setting, type: 'view' },
      });
    }
  };

  handleSettingEditClick = (setting, type) => {
    if (type === SettingType.LEVEL) {
      this.setState({
        levelModal: { visible: true, levelState: setting, type: 'edit' },
      });
    } else {
      this.setState({
        groupModal: { visible: true, groupState: setting, type: 'edit' },
      });
    }
  };

  renderGroups = () => {
    const { groups } = this.state;
    return groups.map((group) => (
      <tr key={`groups-${group.id}`}>
        <td>
          <button
            className="link-button"
            onClick={() =>
              this.setState({
                groupModal: { visible: true, groupState: group, type: 'edit' },
              })
            }
          >
            {group.value}
          </button>
        </td>
        <td>{group.count}</td>
        <td>
          <div className="icon-actions">
            <SquareIconButton
              icon={<EditOutlineIcon />}
              onClick={() =>
                this.handleSettingEditClick(group, SettingType.GROUP)
              }
              title={s('edit')}
              id={`edit-${group.id}`}
            />
            <SquareIconButton
              icon={<DeleteOutlineIcon />}
              onClick={() =>
                this.handleSettingDeleteModal(group.id, SettingType.GROUP)
              }
              title={s('delete')}
              tone="danger"
              id={`delete-${group.id}`}
            />
          </div>
        </td>
      </tr>
    ));
  };

  renderLevels = () => {
    const { levels } = this.state;
    return levels.map((level, index) => (
      <Draggable
        key={`level-${level.id}`}
        draggableId={`level-${level.id}`}
        index={index}
        isDragDisabled={!!this.state.settingState}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={snapshot.isDragging ? 'rbdnd-dragging' : ''}
            key={`level-${level.id}`}
          >
            <td>
              <DragIcon color="#999999" />
            </td>
            <td>
              <button
                className="link-button"
                onClick={() =>
                  this.setState({
                    levelModal: {
                      visible: true,
                      levelState: level,
                      type: 'edit',
                    },
                  })
                }
              >
                {level.value}
              </button>
            </td>
            <td>{level.count}</td>
            <td>
              <div className="icon-actions">
                <SquareIconButton
                  icon={<EditOutlineIcon />}
                  onClick={() =>
                    this.setState({
                      levelModal: {
                        visible: true,
                        levelState: level,
                        type: 'edit',
                      },
                    })
                  }
                  title={s('edit')}
                  id={`edit-${level.id}`}
                />
                <SquareIconButton
                  icon={<DeleteOutlineIcon />}
                  onClick={() =>
                    this.handleSettingDeleteModal(level.id, 'level')
                  }
                  title={s('delete')}
                  tone="danger"
                  id={`delete-${level.id}`}
                />
              </div>
            </td>
          </tr>
        )}
      </Draggable>
    ));
  };

  selectCompayFilter = (companyFilter, isSponsor, isAppVisible) => {
    if (this.state.companyFilter !== companyFilter) {
      this.setState({ companyFilter, isSponsor, isAppVisible });
      this.getCompanies();
    }
  };

  closeSettingModal = (type) => {
    if (type === SettingType.GROUP) {
      this.setState({
        groupModal: { visible: false, groupState: null, type: '' },
      });
    } else if (type === SettingType.LEVEL) {
      this.setState({
        levelModal: { visible: false, levelState: null, type: '' },
      });
    }
  };
  deleteSetting = async () => {
    try {
      this.setState({ loadingSettings: true });
      await Api.club.deleteSetting(this.state.deleteModal.settingID);
      await this.getGroupsAndLevels();
      toast.success(p(`${this.state.deleteModal.type}Deleted`));
    } catch (e) {
      toast.error(e || s('somethingWentWrong'));
    } finally {
      this.handleSettingDeleteModal(false);
      this.setState({ loadingSettings: false });
    }
  };
  render() {
    const {
      order,
      reverse,
      tab,
      levelModal,
      loadingCompanies,
      loadingSettings,
      loadingSponsor,
      groupModal,
    } = this.state;
    const isLoading = loadingCompanies || loadingSettings || loadingSponsor;
    const availableTabs = [
      `${s('companies')}`,
      `${s('levels')}/${s('groups')}`,
      `${s('Statistics')}`,
    ].filter(Boolean);
    return (
      <Container>
        <Loading loading={isLoading} />
        <NavTab
          activeTab={tab}
          tabs={availableTabs}
          setTab={(activeTab) => this.setState({ tab: activeTab })}
        />
        <DeleteModal
          type={s(`the${this.state.deleteModal.type}Small`)}
          visible={this.state.deleteModal.visible}
          handleModal={this.handleSettingDeleteModal}
          modalAction={this.deleteSetting}
        />
        <LinkModal
          visible={this.state.linkModalVisible}
          handleModal={this.handleLinkModal}
          modalAction={this.linkCompany}
        />
        <AlertModal
          visible={this.state.modalVisible}
          handleModal={this.handleModal}
          modalType="DELETION"
          message={a('companyDeleteMsg')}
          subText={s('companyRemoveMsg')}
          modalAction={() => this.removeCompany(this.state.selectedCompanyID)}
        />
        <TabContent activeTab={this.state.tab}>
          <TabPane tabId="1">
            <CompanyStatisticsOverview />
            <FormCard
              title={
                <>
                  <div className="form-card__switch d-none d-md-inline-flex">
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'all' ? ' active' : ''
                      }`}
                      onClick={() => this.selectCompayFilter('all', true, true)}
                    >
                      {s('all')}
                    </button>
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'notVisible'
                          ? ' active'
                          : ''
                      }`}
                      onClick={() =>
                        this.selectCompayFilter('notVisible', true, false)
                      }
                    >
                      {s('notVisible')}
                    </button>
                    <button
                      type="button"
                      className={`form-card__switch-btn${
                        this.state.companyFilter === 'notSponsor'
                          ? ' active'
                          : ''
                      }`}
                      onClick={() =>
                        this.selectCompayFilter('notSponsor', false, true)
                      }
                    >
                      {s('notSponsor')}
                    </button>
                  </div>
                  <span className="d-md-none">
                    {this.state.companyFilter === 'all' && s('all')}
                    {this.state.companyFilter === 'notVisible' &&
                      s('notVisible')}
                    {this.state.companyFilter === 'notSponsor' &&
                      s('notSponsor')}
                  </span>
                </>
              }
              actions={
                <>
                  <div
                    className="d-none d-md-flex align-items-center"
                    style={{ gap: 10 }}
                  >
                    <div className="form noWrap">
                      <div className="form__form-group products-list__search">
                        <input
                          placeholder={p('searchForCompany')}
                          value={this.state.searchText}
                          onChange={this.handleInput}
                          onKeyPress={this.handleSearch}
                          name="search"
                        />
                        <MagnifyIcon />
                      </div>
                    </div>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        className="icon icon--right mb-0"
                        outline
                        size="sm"
                      >
                        <DownloadIcon /> {s('export')} <ChevronDownIcon />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          key="exp2"
                          onClick={this.exportCompaniesXLSX}
                        >
                          {p('exportCompanies')} (XLSX)
                        </DropdownItem>
                        <DropdownItem
                          key="exp4"
                          onClick={this.exportEmployeesXLSX}
                        >
                          {p('exportEmployees')} (XLSX)
                        </DropdownItem>
                        <DropdownItem key="exp1" onClick={this.exportCompanies}>
                          {p('exportCompanies')} (CSV)
                        </DropdownItem>
                        <DropdownItem key="exp3" onClick={this.exportEmployees}>
                          {p('exportEmployees')} (CSV)
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                    <Link to="/companies/create?tab=1">
                      <Button color="primary" size="sm" className="mb-0">
                        {p('createCompany')}
                      </Button>
                    </Link>
                  </div>
                  <div
                    className="d-flex d-md-none align-items-center"
                    style={{ gap: 8 }}
                  >
                    <div className="form noWrap">
                      <div className="form__form-group products-list__search">
                        <input
                          placeholder={p('searchForCompany')}
                          value={this.state.searchText}
                          onChange={this.handleInput}
                          onKeyPress={this.handleSearch}
                          name="search"
                        />
                      </div>
                    </div>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="button"
                        type="button"
                        className="square-icon-btn"
                        caret={false}
                      >
                        <DotsHorizontalIcon />
                      </DropdownToggle>
                      <DropdownMenu right className="dropdown-menu--modern">
                        <DropdownItem
                          active={this.state.companyFilter === 'all'}
                          onClick={() =>
                            this.selectCompayFilter('all', true, true)
                          }
                        >
                          {s('all')}
                        </DropdownItem>
                        <DropdownItem
                          active={this.state.companyFilter === 'notVisible'}
                          onClick={() =>
                            this.selectCompayFilter('notVisible', true, false)
                          }
                        >
                          {s('notVisible')}
                        </DropdownItem>
                        <DropdownItem
                          active={this.state.companyFilter === 'notSponsor'}
                          onClick={() =>
                            this.selectCompayFilter('notSponsor', false, true)
                          }
                        >
                          {s('notSponsor')}
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={this.exportCompaniesXLSX}>
                          {p('exportCompanies')} (XLSX)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportEmployeesXLSX}>
                          {p('exportEmployees')} (XLSX)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportCompanies}>
                          {p('exportCompanies')} (CSV)
                        </DropdownItem>
                        <DropdownItem onClick={this.exportEmployees}>
                          {p('exportEmployees')} (CSV)
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem tag={Link} to="/companies/create?tab=1">
                          {p('createCompany')}
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </>
              }
              bodyClassName="form-card__body--flush"
              className="mb-3"
            >
              <Table responsive bordered className="table--roomy">
                <thead>
                  <tr>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('name')}
                    >
                      {s('name')}
                      <SortDirection
                        active={order === 'name'}
                        direction={reverse}
                      />
                    </th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('employeeCount')}
                    >
                      {s('employees')}
                      <SortDirection
                        active={order === 'employeeCount'}
                        direction={reverse}
                      />
                    </th>
                    <th
                      className="sortable"
                      onClick={() => this.handleSort('companyCategories')}
                    >
                      {s('level')} / {s('category')}
                      <SortDirection
                        active={order === 'companyCategories'}
                        direction={reverse}
                      />
                    </th>
                    <th>
                      {s('sponsor')} / {s('visibleInApp')}
                    </th>
                    {this.state.sponsorViews.enabled && (
                      <th title={sv('viewersColumnInfo')}>
                        {sv('viewersColumn', {
                          month: this.state.sponsorViews.month
                            ? moment(
                                `${this.state.sponsorViews.month}-01`
                              ).format('MMM YYYY')
                            : '',
                        })}
                      </th>
                    )}
                    <th />
                  </tr>
                </thead>
                <tbody>{this.listCompanies()}</tbody>
              </Table>
            </FormCard>
            <Pagination
              items={this.state.companies.total}
              rowsPerPage={[25, 50, 100]}
              onChangePage={this.onChangePage}
            />
          </TabPane>
          <TabPane tabId="2">
            <Row>
              <Col lg={6}>
                <ShareModal
                  visible={levelModal.visible}
                  handleModal={() => {
                    this.closeSettingModal(SettingType.LEVEL);
                    this.setState({
                      levelModal: {
                        visible: false,
                        levelState: null,
                        type: '',
                      },
                    });
                  }}
                >
                  <LevelInformation
                    selectedLevel={levelModal.levelState}
                    type={levelModal.type}
                    onSubmit={this.onSubmitSetting}
                    updateSelectedCompanies={this.updateSelectedCompanies}
                    handleModalTypeChangeToEdit={
                      this.handleModalTypeChangeToEdit
                    }
                  />
                </ShareModal>
                <div className="card__title my-3">
                  <h3 className="page-title">{s('levels')}</h3>
                  <Button
                    onClick={() =>
                      this.setState({
                        levelModal: {
                          visible: true,
                          levelState: null,
                          type: 'create',
                        },
                      })
                    }
                    size="sm"
                    color="primary"
                  >
                    {p('createLevel')}
                  </Button>
                </div>
                <DragDropContext onDragEnd={this.categoryOnDragEnd}>
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 10,
                      paddingBottom: 5,
                      background: '#fff',
                      borderRadius: 6,
                      boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
                    }}
                  >
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>{s('name')}</th>
                          <th>{s('companies')}</th>
                          <th />
                        </tr>
                      </thead>
                      <Droppable droppableId="category-dnd">
                        {(provided) => (
                          <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {this.renderLevels()}
                            {provided.placeholder}
                          </tbody>
                        )}
                      </Droppable>
                    </Table>
                  </div>
                </DragDropContext>
              </Col>
              <Col lg={6}>
                <ShareModal
                  visible={groupModal.visible}
                  handleModal={() => {
                    this.closeSettingModal(SettingType.GROUP);
                    this.setState({
                      groupModal: {
                        visible: false,
                        groupState: null,
                        type: '',
                      },
                    });
                  }}
                >
                  <GroupForm
                    initialValues={{ name: groupModal?.groupState?.value }}
                    type={SettingType.GROUP}
                    settingState={groupModal.groupState}
                    modalType={groupModal.type}
                    onSubmit={this.onSubmitSetting}
                    updateSelectedCompanies={this.updateSelectedCompanies}
                    handleModalTypeChangeToEdit={
                      this.handleModalTypeChangeToEdit
                    }
                  />
                </ShareModal>

                <div className="card__title my-3">
                  <h3 className="page-title">{s('groups')}</h3>
                  <Button
                    onClick={() =>
                      this.setState({
                        groupModal: {
                          visible: true,
                          groupState: null,
                          type: 'create',
                        },
                      })
                    }
                    size="sm"
                    color="primary"
                  >
                    {p('createGroup')}
                  </Button>
                </div>
                <DragDropContext onDragEnd={this.categoryOnDragEnd}>
                  <div
                    style={{
                      display: 'flex',
                      marginTop: 10,
                      paddingBottom: 5,
                      background: '#fff',
                      borderRadius: 6,
                      boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.08)',
                    }}
                  >
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>{s('name')}</th>
                          <th>{s('companies')}</th>
                          <th />
                        </tr>
                      </thead>
                      <Droppable droppableId="category-dnd">
                        {(provided) => (
                          <tbody
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {this.renderGroups()}
                            {provided.placeholder}
                          </tbody>
                        )}
                      </Droppable>
                    </Table>
                  </div>
                </DragDropContext>
              </Col>
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row className="my-1">
              <Col md="12">
                <h3 className="page-title"> </h3>
              </Col>
            </Row>
            <Row className="my-1 mb-3">
              <Col md="12">
                <CompanyCategoryBreakdown />
                <CompanyLevelBreakdown />
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Container>
    );
  }
}
const PageWithHock = (Page) => {
  const WrappedComponent = (props) => {
    const config = useConfig();
    return <Page clubConfig={config} {...props} />;
  };

  return WrappedComponent;
};
export default withRouter(PageWithHock(CompanyListPage));
